<template>
  <div class="p-8 h-full ml-4 mr-4">
    <h1>Agrometeorologia</h1>
    <!-- <h6 class="mb-4">Explore os Gráficos de Satélite: Controle sua Visualização e Acompanhe as Mudanças Ambientais em Tempo Real!</h6> -->
    <div class="alert alert-info alert-dismissible fade show" role="alert">
      <strong>Dados Climáticos:</strong>
      Descubra a Agrometeorologia e impulsione sua agricultura! Aproveite dados climáticos essenciais para planejar seu plantio, irrigação e manejo de culturas.
      <feather-icon class="cursor-pointer close-button-alert" icon="XIcon" size="16" id="button-close" />

    </div>
    <section class="alert m-0 p-0">
      <div class="row row-labels">
        <label class="col-md-6">Tipo de Relatório
          <feather-icon class="cursor-pointer" icon="InfoIcon" size="16" id="report-type-info-popover-target" />
        </label>
        <b-popover target="report-type-info-popover-target" triggers="hover" placement="top">
          <!-- <template #title class="title-popover">Relatórios</template> -->
          <div>
            <b>Balanço Hídrico:</b>
            <span>
              Calcula a quantidade de água disponível no solo ao longo do tempo, levando em consideração fatores como precipitação, evapotranspiração, armazenamento de água no solo e percolação.
            </span>
          </div>
          <hr>
          <div>
            <b>Planejamento Ciclo:</b>
            <span>
              O Planejamento Ciclo é uma estratégia que visa otimizar a gestão de processos, projetos ou atividades ao longo de um ciclo de tempo específico.
            </span>
          </div>
          <hr>
          <div>
            <b>Smart Rural</b>
            <span>
              Aplicação de tecnologias avançadas e inovações digitais no contexto de áreas rurais para melhorar a qualidade de vida, impulsionar o desenvolvimento econômico e promover a sustentabilidade.
            </span>
          </div>
          <hr>
          <div>
            <b>Índica Seca:</b>
            <span>
              Calculado com base em diversos fatores, como precipitação, umidade do solo, temperatura e evaporação.
            </span>
          </div>
        </b-popover>      
      </div>
      <div class="row mb-5">
        <section class="col-md-12">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">Balanço Hídrico</b-button>
            <b-button>Planejamento Ciclo</b-button>
            <b-button>Smart Rural</b-button>
            <b-button>Índice Seca</b-button>
          </b-button-group>
        </section>
      </div>
      <div class="row row-labels">
        <label class="col-md-3">Análise</label>
        <label class="col-md-3">Tipo</label>
      </div>
      <div class="row mb-0">
        <section class="col-md-3">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">Observado</b-button>
            <b-button>Previsto</b-button>
          </b-button-group>
        </section>
        <section class="col-md-3">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">Gráfico</b-button>
            <b-button>Tabela</b-button>
          </b-button-group>
        </section>
      </div>
     
      <div class="row row-labels mt-5">
        <label class="col-md-6">Análise</label>
        <label class="col-md-6">Região</label>
      </div>
      <div class="row mb-0">
        <section class="col-md-6">
          <div class="form-group">
            <v-select autocomplete :closeOnSelect="false" :options="[]" class="analitcs-dates">
            </v-select>
          </div>
        </section>
        <section class="col-md-6">
          <div class="form-group">
            <v-select autocomplete :closeOnSelect="false" :options="[]" class="analitcs-dates">
            </v-select>
          </div>
        </section>
        
      </div>
      <div class="row mt-5 mb-5">
        <section class="col-md-2">
          <vs-button class="btn btn-xs btn-secondary rounded-pill" icon-pack="feather"
            icon="icon-search">Consultar</vs-button>
        </section>
        <section class="col-md-2 ml-5">
          <vs-button class="btn btn-secondary rounded-pill" color="primary" icon-pack="feather"
            icon="icon-share"></vs-button>
        </section>


      </div>
    </section>

    <div class="">
      
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import FeatherIcon from '../../../@core/components/feather-icon/FeatherIcon.vue';
import vSelect from "vue-select";
import { BPopover } from 'bootstrap-vue';

export default {
  data() {
    return {
      dateFilter: "",
      languages: lang
    }
  },
  components: {
    Datepicker,
    FeatherIcon,
    vSelect,
    BPopover
  }
}



document.addEventListener('DOMContentLoaded', e => {
  $('#input-datalist').autocomplete()
}, false);
</script>

<style>
  

</style>